import { DashboardOverview } from 'src/core/types';
import axios from './axios';
import { useQuery } from 'react-query';

const fetchDashboardOverview = (startDate: string, endDate: string) =>
  axios
    .get<DashboardOverview>(
      '/posht/pishkhan/overview/' +
        `?from_date=${startDate}` +
        `&to_date=${endDate}`,
    )
    .then((res) => res.data);

export interface UseDashboardOverviewProps {
  endDate: string;
  startDate: string;
}

export function useDashboardOverview(props: UseDashboardOverviewProps) {
  const { endDate, startDate } = props;

  return useQuery<DashboardOverview>(
    ['dashboard-overview', startDate, endDate],
    () => fetchDashboardOverview(startDate, endDate),
  );
}
